"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _DropdownList = _interopRequireDefault(require("react-widgets/lib/DropdownList"));
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down5"));
var _bin = _interopRequireDefault(require("cccisd-icons/bin"));
var _plus = _interopRequireDefault(require("cccisd-icons/plus2"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _ActionCondition = _interopRequireDefault(require("./ActionCondition.js"));
var _InfoLabel = _interopRequireDefault(require("../../../../components/InfoLabel"));
var _admin = require("../../../../selectors/admin.js");
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var BranchConfig = function BranchConfig(_ref) {
  var branchIndex = _ref.branchIndex,
    config = _ref.config,
    conditionKeyFrequencies = _ref.conditionKeyFrequencies,
    deleteBranch = _ref.deleteBranch,
    deploymentId = _ref.deploymentId,
    errors = _ref.errors,
    fields = _ref.fields,
    formulaMetrics = _ref.formulaMetrics,
    hideDefaultLabel = _ref.hideDefaultLabel,
    isDefault = _ref.isDefault,
    isReorderingBranches = _ref.isReorderingBranches,
    nextConditionKey = _ref.nextConditionKey,
    renderMoveBranches = _ref.renderMoveBranches,
    setNextConditionKey = _ref.setNextConditionKey,
    updateConfig = _ref.updateConfig;
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    firstLoad = _useState2[0],
    setFirstLoad = _useState2[1];
  var _useState3 = (0, _react.useState)(config.branchName || ''),
    _useState4 = _slicedToArray(_useState3, 2),
    branchName = _useState4[0],
    setBranchName = _useState4[1];
  var _useState5 = (0, _react.useState)(config.conditions || [{}]),
    _useState6 = _slicedToArray(_useState5, 2),
    conditions = _useState6[0],
    setConditions = _useState6[1];
  var _useState7 = (0, _react.useState)(config.formulaCompareType || null),
    _useState8 = _slicedToArray(_useState7, 2),
    formulaCompareType = _useState8[0],
    setFormulaCompareType = _useState8[1];
  var _useState9 = (0, _react.useState)(config.formulaCompareValue || ''),
    _useState0 = _slicedToArray(_useState9, 2),
    formulaCompareValue = _useState0[0],
    setFormulaCompareValue = _useState0[1];
  var _useState1 = (0, _react.useState)(config.formulaId || null),
    _useState10 = _slicedToArray(_useState1, 2),
    formulaId = _useState10[0],
    setFormulaId = _useState10[1];
  var _useState11 = (0, _react.useState)(true),
    _useState12 = _slicedToArray(_useState11, 2),
    isBranchExpanded = _useState12[0],
    setIsBranchExpanded = _useState12[1];
  var _useState13 = (0, _react.useState)(false),
    _useState14 = _slicedToArray(_useState13, 2),
    isReorderingConditions = _useState14[0],
    setIsReorderingConditions = _useState14[1];
  var projectDeployments = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getCurrentProjectDeployments)(state.assignment.admin);
  });
  var currentRoleDcws = projectDeployments.filter(function (d) {
    return !d.archived && d.deploymentId !== deploymentId && d.roleHandle === currentRoleType();
  });

  /* /////////////////////////////////////////////////////////////////////////
  // LIFECYCLE METHODS //////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  (0, _react.useEffect)(function () {
    if (!firstLoad) {
      setBranchName(config.branchName || '');
      setConditions(config.conditions);
      setFormulaCompareType(config.formulaCompareType || null);
      setFormulaCompareValue(config.formulaCompareValue || '');
      setFormulaId(config.formulaId || null);
    } else {
      var startingConditions = _toConsumableArray(conditions);
      if (startingConditions.length === 1 && !startingConditions[0].key) {
        var newConditions = [_objectSpread(_objectSpread({}, startingConditions[0]), {}, {
          key: nextConditionKey
        })];
        setNextConditionKey(nextConditionKey + 1);
        changeField({
          target: {
            name: 'conditions',
            value: newConditions
          }
        }, setConditions);
      }
      setFirstLoad(false);
    }
  }, [config]);
  (0, _react.useEffect)(function () {
    if (!isBranchExpanded && errors) {
      setIsBranchExpanded(true);
    }
  }, [errors]);
  (0, _react.useEffect)(function () {
    if (!isBranchExpanded && hideDefaultLabel) {
      setIsBranchExpanded(true);
    }
  }, [hideDefaultLabel]);

  /* /////////////////////////////////////////////////////////////////////////
  // GENERAL FUNCTIONS //////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  function changeField(event, customSet) {
    var updatedConfig = _objectSpread({}, config);
    updatedConfig[event.target.name] = event.target.value;
    updateConfig(updatedConfig);
    customSet(event.target.value);
  }
  function currentRoleType() {
    var chosenDeployment = null;
    switch (fields.respondentConfig.value) {
      case 'managed':
        return fields.respondentSelection.value;
      case 'previous':
        chosenDeployment = projectDeployments.find(function (d) {
          return d.deploymentId === Number(fields.respondentSelection.value);
        });
        return chosenDeployment && chosenDeployment.roleHandle || undefined;
      default:
        return 'respondent';
    }
  }
  var renderCollapseArrow = /*#__PURE__*/_react["default"].createElement("div", {
    onClick: function onClick() {
      return setIsBranchExpanded(!isBranchExpanded);
    },
    className: (0, _classnames["default"])(_style["default"].collapseArrow, isBranchExpanded ? _style["default"].expanded : _style["default"].collapsed)
  }, /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null));

  /* /////////////////////////////////////////////////////////////////////////
  // CONDITION-RELATED //////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  function addCondition() {
    var updatedConditions = [].concat(_toConsumableArray(conditions), [{
      action: 'message',
      completionMessage: 'You have completed the survey! Thank you for your response!',
      key: nextConditionKey
    }]);
    setNextConditionKey(nextConditionKey + 1);
    changeField({
      target: {
        name: 'conditions',
        value: updatedConditions
      }
    }, setConditions);
  }
  function deleteCondition(index) {
    return function () {
      (0, _cccisdConfirm["default"])({
        message: 'Delete Condition',
        description: 'Are you sure you want to delete this condition?'
      }).then(function () {
        // tinymce was re-using the same instance from the deleted
        // ActionCondition, so we must force it to re-initialize by
        // unmounting, then remounting a short time later.
        setIsReorderingConditions(true);
        changeField({
          target: {
            name: 'conditions',
            value: conditions.filter(function (_, i) {
              return i !== index;
            })
          }
        }, setConditions);
        setTimeout(function () {
          return setIsReorderingConditions(false);
        }, 25);
      });
    };
  }
  var renderAddConditionButton = /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-secondary",
    onClick: addCondition,
    type: "button"
  }, /*#__PURE__*/_react["default"].createElement(_plus["default"], null), /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      marginLeft: '0.75rem'
    }
  }, "Add condition"));
  function updateConditionConfig(index) {
    return function (updatedConditionConfig) {
      var updatedConditions = [];
      conditions.forEach(function (c, i) {
        updatedConditions.push(i === index ? updatedConditionConfig : c);
      });
      changeField({
        target: {
          name: 'conditions',
          value: updatedConditions
        }
      }, setConditions);
    };
  }

  /* /////////////////////////////////////////////////////////////////////////
  // BRANCH-RELATED /////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  function renderBranchName() {
    if (isDefault) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(_style["default"].indentedLabel, isBranchExpanded ? null : _style["default"].collapsedLabel)
      }, /*#__PURE__*/_react["default"].createElement("strong", null, "Default Branching Rule"));
    }
    if (!isBranchExpanded) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(_style["default"].indentedLabel, _style["default"].collapsedLabel)
      }, /*#__PURE__*/_react["default"].createElement("strong", null, "Branch Name:"), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].collapsedField
      }, branchName));
    }
    var hasError = (0, _get2["default"])(errors, 'branchName');
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(_style["default"].flexExpand, hasError ? 'is-invalid' : '')
    }, /*#__PURE__*/_react["default"].createElement("label", {
      className: "form-label ".concat(_style["default"].indentedLabel)
    }, "Branch Name"), /*#__PURE__*/_react["default"].createElement("input", {
      className: "form-control",
      name: "branchName",
      onChange: function onChange(e) {
        return changeField(e, setBranchName);
      },
      type: "text",
      value: branchName
    }), hasError && /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-danger"
    }, hasError));
  }
  var renderDeleteBranchButton = isDefault ? null : /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
    title: "Delete Branching Rule"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-sm btn-danger ".concat(_style["default"].deleteButton),
    onClick: deleteBranch,
    type: "button"
  }, /*#__PURE__*/_react["default"].createElement(_bin["default"], null)));
  function renderFormulaIdDropdown() {
    var hasError = (0, _get2["default"])(errors, 'formulaId');
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(hasError ? 'is-invalid' : '', _style["default"].flexExpand)
    }, /*#__PURE__*/_react["default"].createElement("label", {
      className: "form-label"
    }, /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
      label: "Formula",
      tooltip: "The formula whose value we will compare against. Note that all formulas associated with this Quest Project are listed."
    })), /*#__PURE__*/_react["default"].createElement(_DropdownList["default"], {
      data: formulaMetrics,
      onChange: function onChange(e) {
        return changeField({
          target: {
            name: 'formulaId',
            value: e.variableId
          }
        }, setFormulaId);
      },
      placeholder: "--- Choose a Formula ---",
      itemComponent: function itemComponent(_ref2) {
        var item = _ref2.item;
        if (item) {
          return item.label || item.reportHeader || '';
        }
        return '';
      },
      value: formulaId,
      valueComponent: function valueComponent(_ref3) {
        var item = _ref3.item;
        if (item) {
          return item.label || item.reportHeader || '';
        }
        return '';
      },
      valueField: "variableId"
    }), hasError && /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-danger"
    }, hasError));
  }
  function renderFormulaCompareTypeDropdown() {
    var comparisonTypes = [{
      label: 'Equals',
      value: 'eq'
    }, {
      label: 'Greater Than',
      value: 'gt'
    }, {
      label: 'Greater Than or Equal To',
      value: 'gte'
    }, {
      label: 'Less Than',
      value: 'lt'
    }, {
      label: 'Less Than or Equal To',
      value: 'lte'
    }];
    var hasError = (0, _get2["default"])(errors, 'formulaCompareType');
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(hasError ? 'is-invalid' : '', _style["default"].formulaPart, _style["default"].flexExpand)
    }, /*#__PURE__*/_react["default"].createElement("label", {
      className: "form-label"
    }, "Comparison Type"), /*#__PURE__*/_react["default"].createElement(_DropdownList["default"], {
      data: comparisonTypes,
      onChange: function onChange(e) {
        return changeField({
          target: {
            name: 'formulaCompareType',
            value: e.value
          }
        }, setFormulaCompareType);
      },
      placeholder: "--- Choose a Comparison Type ---",
      textField: "label",
      value: formulaCompareType,
      valueComponent: function valueComponent(_ref4) {
        var item = _ref4.item;
        return item ? item.label : '';
      },
      valueField: "value"
    }), hasError && /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-danger"
    }, hasError));
  }
  function renderFormulaCompareValue() {
    var hasError = (0, _get2["default"])(errors, 'formulaCompareValue');
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(hasError ? 'is-invalid' : '', _style["default"].formulaPart, _style["default"].flexExpand)
    }, /*#__PURE__*/_react["default"].createElement("label", {
      className: "form-label"
    }, "Comparison Value"), /*#__PURE__*/_react["default"].createElement("input", {
      className: "form-control",
      name: "formulaCompareValue",
      onChange: function onChange(e) {
        return changeField(e, setFormulaCompareValue);
      },
      type: "number",
      value: formulaCompareValue
    }), hasError && /*#__PURE__*/_react["default"].createElement("div", {
      className: "text-danger"
    }, hasError));
  }

  /* /////////////////////////////////////////////////////////////////////////
  // RENDER /////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].branchWrapper
  }, !hideDefaultLabel && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].branchNameWrapper
  }, renderCollapseArrow, renderBranchName(), !isDefault && isBranchExpanded && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].flexRight
  }, renderDeleteBranchButton, renderMoveBranches)), isBranchExpanded && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !isDefault && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].formulaWrapper
  }, renderFormulaIdDropdown(), renderFormulaCompareTypeDropdown(), renderFormulaCompareValue()), conditions.map(function (conditionConfig, index) {
    return /*#__PURE__*/_react["default"].createElement(_ActionCondition["default"], {
      conditionConfig: conditionConfig,
      conditionKeyFrequencies: conditionKeyFrequencies,
      conditions: conditions,
      currentRoleDcws: currentRoleDcws,
      deleteCondition: deleteCondition(index),
      deploymentId: deploymentId,
      errors: (0, _get2["default"])(errors, "conditions.".concat(index)),
      fields: fields,
      index: index,
      isReorderingBranches: isReorderingBranches || isReorderingConditions,
      key: "".concat(branchIndex, "_").concat(index),
      updateConditionConfig: updateConditionConfig(index)
    });
  }), renderAddConditionButton));
};
BranchConfig.propTypes = {
  branchIndex: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  config: _propTypes["default"].object,
  conditionKeyFrequencies: _propTypes["default"].array,
  deleteBranch: _propTypes["default"].func,
  deploymentId: _propTypes["default"].number,
  errors: _propTypes["default"].object,
  fields: _propTypes["default"].object,
  formulaMetrics: _propTypes["default"].array,
  hideDefaultLabel: _propTypes["default"].bool,
  isDefault: _propTypes["default"].bool,
  isReorderingBranches: _propTypes["default"].bool,
  nextConditionKey: _propTypes["default"].number,
  renderMoveBranches: _propTypes["default"].node,
  setNextConditionKey: _propTypes["default"].func,
  updateConfig: _propTypes["default"].func
};
var _default = exports["default"] = BranchConfig;